import { ApiService } from '../Services/APIService';
import { StorageUtils } from "../Utils/StorageUtils";

export const FreeGenerationService = {
  /**
   * Get user's current generation status
   */
  getGenerationStatus: async () => {
    const token = StorageUtils.getUserData()?.token;
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    ApiService.setAuthToken(token);
    return ApiService.get('/free-generations/status');
  },

  /**
   * Debug: Manually decrement user's generation count
   */
  decrementUserGeneration: async () => {
    const token = StorageUtils.getUserData()?.token;
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    ApiService.setAuthToken(token);
    return ApiService.post('/free-generations/decrement');
  },

  /**
   * Debug: Reset user's generation count
   */
  resetUserGeneration: async () => {
    const token = StorageUtils.getUserData()?.token;
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    ApiService.setAuthToken(token);
    return ApiService.post('/free-generations/reset');
  }
};

